import React, { useCallback, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { PATH_TALENT_CENTER } from '../../system/constants';
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { AppContext } from '../../common/contexts';
import { LayoutContext } from '../../common/contexts';
import {
    DASHBOARD_MY_PROFILE,
    DASHBOARD_MY_JOBS,
    DASHBOARD_MY_SETTINGS,
    DASHBOARD_MY_MESSAGES,
    DASHBOARD_MY_CALENDAR,
    DASHBOARD_TALENT_CENTER,
    BASE_URL,
    DASHBOARD_ID_MY_SETTINGS,
    DASHBOARD_ID_MY_PROFILE,
    DASHBOARD_ID_MY_JOBS,
    DASHBOARD_ID_MY_MESSAGES,
    DASHBOARD_ID_MY_CALENDAR,
} from '../../common/constants';
import { getMyCalendarCaption } from '../../common/calendarHelper';
import { getUnreadMessageCountByDashboardData } from '../../common/dashboardHelper';

import NavigationButton from '../../dashboard/subComponents/NavigationButton';
import PhotoSection from '../../dashboard/subComponents/PhotoSection';

import _get from 'lodash/get';
import _reduce from 'lodash/reduce';
import _values from 'lodash/values';
import Footer from '../../dashboard/subComponents/Footer';

const styles = theme => ({
    root: {
        backgroundColor: '#FAFAFC',
        // width: '256px',
        height: '100%',
        textAlign: 'center',
        // marginLeft: '64px',
        // marginRight: '64px',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('xl')]: { width: '256px', marginLeft: '64px' },
        [theme.breakpoints.down('lg')]: { marginTop: 16 },
    },
});

const getDefns = params => {
    const { props, profilePicUrl, dashboard, handleClickButton, dashboardData, dashboardDataEmpMember, currentThreadId, handleClickTalentCenterButton } = params;
    const {
        classes: { root: rootCls },
    } = props;

    const unreadMessagesCount = getUnreadMessageCountByDashboardData({ dashboardData, dashboardDataEmpMember, currentThreadId });

    const myCalendarCaption = getMyCalendarCaption({ dashboardData });

    const unreadNewApplicants = _values(_get(dashboardData, 'unreadNewApplicants'));
    const myJobsCaption = _reduce(unreadNewApplicants, (total, userIdList = []) => total + userIdList.length, 0);

    const defns = {
        root: {
            className: rootCls,
        },
        photoSection: {
            photoUrl: profilePicUrl,
        },
        myProfileButton: {
            label: DASHBOARD_MY_PROFILE,
            selected: dashboard === DASHBOARD_MY_PROFILE,
            onClick: handleClickButton.bind(null, DASHBOARD_ID_MY_PROFILE),
        },
        myJobsButton: {
            label: DASHBOARD_MY_JOBS,
            selected: dashboard === DASHBOARD_MY_JOBS,
            onClick: handleClickButton.bind(null, DASHBOARD_ID_MY_JOBS),
            caption: myJobsCaption,
        },
        mySettingsButton: {
            label: DASHBOARD_MY_SETTINGS,
            selected: dashboard === DASHBOARD_MY_SETTINGS,
            onClick: handleClickButton.bind(null, DASHBOARD_ID_MY_SETTINGS),
        },
        talentCenterButton: {
            label: DASHBOARD_TALENT_CENTER,
            selected: dashboard === DASHBOARD_TALENT_CENTER,
            onClick: handleClickTalentCenterButton,
        },
        myMessagesButton: {
            label: DASHBOARD_MY_MESSAGES,
            selected: dashboard === DASHBOARD_MY_MESSAGES,
            onClick: handleClickButton.bind(null, DASHBOARD_ID_MY_MESSAGES),
            caption: unreadMessagesCount,
        },
        myCalendarButton: {
            label: DASHBOARD_MY_CALENDAR,
            selected: dashboard === DASHBOARD_MY_CALENDAR,
            onClick: handleClickButton.bind(null, DASHBOARD_ID_MY_CALENDAR),
            caption: myCalendarCaption,
        },
    };
    return defns;
};

const LeftNavigation = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const appContext = useContext(AppContext);
    const context = useContext(LayoutContext);
    const { dashboard, setCurrentDashboard, dashboardData, dashboardDataEmpMember, currentThreadId } = context;
    const profilePicUrl = _get(appContext, 'currentEmployer.profilePicUrl');
    const history = useHistory();

    const theme = useTheme();
    const lgMatches = useMediaQuery(theme.breakpoints.down('lg'));
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------
    const handleClickButton = useCallback(
        dashboardId => {
            setCurrentDashboard(dashboardId);
        },
        [setCurrentDashboard],
    );

    const handleClickTalentCenterButton = useCallback(() => {
        history.push(`${BASE_URL}${PATH_TALENT_CENTER}`);
    }, [history]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ props, profilePicUrl, dashboard, handleClickButton, dashboardData, dashboardDataEmpMember, currentThreadId, handleClickTalentCenterButton });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div>
            {mdMatches ? null : (
                <div {...defns.root}>
                    <Grid container spacing={1} justify="center">
                        {lgMatches ? null : (
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <PhotoSection {...defns.photoSection} />
                            </Grid>
                        )}

                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myProfileButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myCalendarButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myJobsButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myMessagesButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.talentCenterButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.mySettingsButton} />
                        </Grid>
                    </Grid>
                    <span style={{ marginTop: '25px' }}>
                        <Footer />
                    </span>
                </div>
            )}
        </div>
    );
};

export default withStyles(styles)(LeftNavigation);
